import React, { useEffect, useState, useCallback } from "react";
import { Table, Input, Button, Space, Modal, Form, Row, Col, TreeSelect, Typography } from 'antd';
import { getCategoryList, getProductList } from '../util/api';
import '../qualityGradient/index.less';
const ProductListModal = ({ type = 1, handleCancel, handleProduct }) => {
  const [form] = Form.useForm();
  const [treeData, setTreeData] = useState([]);
  const [pageConfig, setPageConfig] = useState({ page: 1, page_size: 10 });
  const [dataSource, setDataSource] = useState([]);
  const [totalPage, setTotalPage] = useState(1);
  const [baseList, setBaseList] = useState([]);
  const [selectItems, setSelectItems] = useState({ selectedRowKeys: [], selectedRows: [] });

  const rowSelection = {
    selectedRowKeys: selectItems.selectedRowKeys || [],
    onChange: (selectedRowKeys, selectedRows) => {
      if (selectItems.selectedRowKeys.length > selectedRowKeys.length) {
        //取消
        const filter_id = selectItems.selectedRowKeys.filter(
          (item) => !selectedRowKeys.includes(item.sale_id)
        );
        const filterBaseList = baseList.filter(
          (item) => !filter_id.includes(item.sale_id)
        );
        setBaseList(filterBaseList);
      }
      setSelectItems({ selectedRowKeys, selectedRows });
    },
    getCheckboxProps: (record) => ({
      disabled: !record.can_check,
    }),
  };
  const columns = [
    { title: '商品分类', key: 'category_list', dataIndex: 'category_list', align: 'center', },
    { title: 'SKU编码', key: 'sku_no', dataIndex: 'sku_no', align: 'center', },
    {
      title: '商品名称', key: 'sale_name', dataIndex: 'sale_name', align: 'center', render: (text, record) => {
        const { false_reason, can_check } = record;
        return <><div>{text}</div><div><Typography.Link>{can_check ? null : false_reason}</Typography.Link></div></>;
      }
    },
    { title: 'ITEM单位', key: 'item_unit', dataIndex: 'item_unit', align: 'center', },
  ];
  const calcList = () => {
    const res = new Map();
    return [...baseList, ...selectItems.selectedRows].filter((item) => !res.has(item['sale_id']) && res.set(item['sale_id'], 1));
  };
  useEffect(() => {
    const getCagegory = async () => {
      const result = await getCategoryList();
      const { data, code } = result.data || {};
      if (code === 0) {
        setTreeData(data);
      }
    };
    getCagegory();
  }, []);// eslint-disable-next-line react-hooks/exhaustive-deps
  const tablePageChange = (page, page_size) => {
    setBaseList(calcList());
    setPageConfig({ ...pageConfig, page, page_size });
  };
  useEffect(() => {
    const getProduct = async () => {
      const values = form.getFieldsValue();
      setBaseList(calcList());
      const result = await getProductList({
        type,
        ...values,
        ...pageConfig
      });
      const { data: { list, total } = {}, code } = result.data || {};
      if (code === 0) {
        const selectedRows = list.filter((x) =>
          baseList.some((y) => y.sale_id === x.sale_id)
        );
        const selectedRowKeys = selectedRows.map((item) => item.sale_id);
        setSelectItems({ selectedRowKeys, selectedRows });
        setDataSource(list);
        setTotalPage(total);
      }
    };
    getProduct();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageConfig]);
  const onFinish = () => {
    setPageConfig({ ...pageConfig, page: 1 });
  };
  const onReset = () => {
    form.resetFields();
    setPageConfig({ ...pageConfig, page: 1 });
  };
  const onCancel = useCallback(() => {
    handleCancel();
  }, [handleCancel]);

  const handleSubmit = () => {
    const selectedRows = calcList();
    setBaseList(selectedRows);
    handleProduct(selectedRows);
  };
  return (
    <Modal
      title="添加商品"
      destroyOnClose
      open={true}
      width={1000}
      onCancel={onCancel}
      footer={[
        <div key="submit" className="custom-form-btns">
          <Button type="primary" onClick={handleSubmit} disabled={!selectItems.selectedRowKeys.length}>
            确定
          </Button>
          <Button onClick={onCancel}>
            取消
          </Button>
        </div>,
      ]}
    >
      <Form onFinish={onFinish} form={form}>
        <Row gutter={24}>
          <Col span={8}>
            <Form.Item label="商品分类" name="category_id">
              <TreeSelect
                maxTagCount={1}
                showSearch
                style={{ width: '100%', }}
                treeDataSimpleMode
                fieldNames={{ label: 'name', value: 'id', children: 'children' }}
                dropdownStyle={{ maxHeight: 200, overflow: 'auto', }}
                placeholder=""
                allowClear
                multiple
                filterTreeNode={(inputValue, treeNode) => treeNode.name.includes(inputValue)}
                treeData={treeData}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="商品SKU" name='sku_no'>
              <Input />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="商品名称" name={'sku_name'}>
              <Input />
            </Form.Item>
          </Col>
          <Col span={8} offset={16}>
            <Form.Item wrapperCol={{ span: 8, offset: 8 }}>
              <Space>
                <Button type="primary" htmlType="submit">查询</Button>
                <Button onClick={onReset}>重置</Button>
              </Space>
            </Form.Item>
          </Col>
        </Row>
      </Form>
      <Table
        columns={columns}
        dataSource={dataSource}
        rowKey='sale_id'
        className="quality-table-cell"
        locale={{ emptyText: '未搜索到商品' }}
        rowSelection={rowSelection}
        pagination={{
          showSizeChanger:true,
          pageSize: pageConfig.page_size,
          total: totalPage,
          current: pageConfig.page,
          onChange: tablePageChange,
        }} />
    </Modal>
  );
};

export default ProductListModal;